import { Add } from '@mui/icons-material';
import styled from '@emotion/styled';
import { Button, Title, Description } from 'Components/ui';
import Breadcrumb from './Breadcrumb';

interface InstructorsHeaderProps {
  breadcrumbParent: string;
  breadcrumbCurrent: string;
  onBack: () => void;
  title: string;
  subtitle: string;
  addLabel: string;
  onAdd: () => void;
  /** Muestra el botón de alta solo si el usuario tiene permiso. */
  canAdd?: boolean;
}

const TitleRow = styled.div({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: 24,
});

const Stack = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: 9,
});

/**
 * Organismo de cabecera: migas de pan, título con su subtítulo y el botón de
 * alta. Reutiliza los primitivos `Title` y `Description` del hub.
 */
const InstructorsHeader = ({
  breadcrumbParent,
  breadcrumbCurrent,
  onBack,
  title,
  subtitle,
  addLabel,
  onAdd,
  canAdd = true,
}: InstructorsHeaderProps) => (
  <header>
    <Breadcrumb parentLabel={breadcrumbParent} currentLabel={breadcrumbCurrent} onParentClick={onBack} />
    <TitleRow>
      <Stack>
        <Title as="h1" size="page">
          {title}
        </Title>
        <Description size="page">{subtitle}</Description>
      </Stack>
      {canAdd ? (
        <Button type="button" variant="primary" onClick={onAdd}>
          <Add />
          {addLabel}
        </Button>
      ) : null}
    </TitleRow>
  </header>
);

export default InstructorsHeader;
